import { useEffect, useRef, useState } from 'react';
import SwiperCore from 'swiper';

export const useSwiperSlider = () => {
  const [swiper, setSwiper] = useState<SwiperCore>();
  const prevRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const nextRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    if (prevRef.current === undefined) {
      return;
    }

    if (!swiper || typeof swiper?.params?.navigation === 'boolean') {
      return;
    }
    const navigation = swiper.params?.navigation;

    if (navigation) {
      navigation.prevEl = prevRef.current;
      navigation.nextEl = nextRef.current;
    }
    swiper.navigation?.init();
    swiper.navigation?.update();

    if (swiper.isBeginning) {
      prevRef.current.classList.add('hidden');
    }

    if (swiper.isEnd) {
      nextRef.current.classList.add('hidden');
    }
  }, [swiper]);

  return { swiper, setSwiper, prevRef, nextRef };
};
